import { motion } from 'framer-motion';
import { personalData } from '../data/content';
import { CheckCircle2, Heart } from 'lucide-react';

export default function Skills() {
  return (
    <section id="skills" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16">
          {/* Skills Column */}
          <div>
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="mb-8"
            >
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Core Competencies</h2>
              <p className="text-gray-600 mb-8">
                A blend of strategic leadership, operational excellence, and community-focused advocacy.
              </p>
            </motion.div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {personalData.skills.map((skill, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 10 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.05 }}
                  className="flex items-center gap-3 p-4 bg-gray-50 rounded-lg border border-gray-100 hover:border-emerald-200 hover:bg-emerald-50 transition-colors"
                >
                  <CheckCircle2 className="text-emerald-600 w-5 h-5 flex-shrink-0" />
                  <span className="font-medium text-gray-800">{skill}</span>
                </motion.div>
              ))}
            </div>
          </div>

          {/* Interests Column */}
          <div>
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="mb-8"
            >
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Personal Interests</h2>
              <p className="text-gray-600 mb-8">
                Outside of work, I stay active and engaged with my community and family.
              </p>
            </motion.div>

            <div className="flex flex-wrap gap-3">
              {personalData.interests.map((interest, index) => (
                <motion.span
                  key={index}
                  initial={{ opacity: 0, scale: 0.9 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.05 }}
                  className="inline-flex items-center gap-2 px-4 py-2 bg-emerald-100 text-emerald-800 rounded-full text-sm font-medium"
                >
                  <Heart className="w-4 h-4" />
                  {interest}
                </motion.span>
              ))}
            </div>

            {/* Quote or Statement */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.4 }}
              className="mt-12 p-8 bg-emerald-900 text-white rounded-2xl relative overflow-hidden"
            >
              <div className="relative z-10">
                <p className="text-lg font-light italic leading-relaxed opacity-90">
                  "Driven by a deep commitment to equity, sustainability, and community empowerment."
                </p>
              </div>
              <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full blur-2xl -mr-16 -mt-16" />
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
